import { render, staticRenderFns } from "./CatalogueCategoriesDropdown.vue?vue&type=template&id=68702c20"
import script from "./CatalogueCategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./CatalogueCategoriesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports